import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ApiResponse } from 'src/app/_model/policy/apiResponse';
import { RulesService } from 'src/app/_services';
import { Constantes } from 'src/app/_shared/var.constant';
import { BreadcrumbService } from '../../breadcrumb.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-pyme-management',
    templateUrl: './pyme-management.component.html',
    styleUrls: ['./pyme-management.css']
})
export class PymeManagementComponent implements OnInit {
    constantes = new Constantes();
    items: MenuItem[];
    activeItem: MenuItem;
    itemSelect = 0;
    mobile: any;
    userRol: any;
    blockedDocument = false;
    showBackOffice = false;
    urlRedirectBackOffice = environment.URL_PYME_BACK_OFFICE;

    constructor(private breadcrumbService: BreadcrumbService,
        public rulesServices: RulesService) { }

    ngOnInit(): void {
        this.cargarBreadCrum();
        const currentUser = JSON.parse(sessionStorage.getItem('access_token'));
        this.userRol = currentUser.user.roles;
        this.seguridadVerBackOffice();
        // this.showBackOffice = true;
        // this.itemSelect = 1;
        this.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        setTimeout(() => {
            this.responsive();
        }, 100);

    }

    cargarBreadCrum() {
        this.breadcrumbService.setItems([
            { label: 'Inicio', routerLink: ['/home'] },
            { label: 'PYME' },
            { label: 'Back - Office' },
        ]);
    }

    selectApp(item) {
        this.itemSelect = item;
    }
    responsive() {
        const elm1 = <HTMLElement>document.getElementById('negocio');
        const elm2 = <HTMLElement>document.getElementById('labelNeg');
        const elm3 = <HTMLElement>document.getElementById('imgNeg');
        const elm4 = <HTMLElement>document.getElementById('contenedorImg');
        const elm5 = <HTMLElement>document.getElementById('bienvenidos');
        if (this.mobile) {
            elm1.style.width = '140px';
            elm1.style.height = '58px';
            elm1.style.marginTop = '98px';
            elm1.style.marginLeft = '20px';
            elm2.style.fontSize = '1.4em';
            elm2.style.padding = '10px';
            elm2.style.paddingTop = '19px';
            elm3.style.height = '255px ! important';
            elm4.style.width = '100%';
            elm4.style.marginTop = '-5%';
            elm5.style.marginTop = '-4%';
            elm5.style.marginLeft = '0%';
            elm5.style.position = 'absolute';
        }
    }

    seguridadVerBackOffice() {
        this.blockedDocument = true;
        const ruleParam = {
            rolesId: this.userRol,
            rule: this.constantes.showOffice
        };
        this.rulesServices.intlLatamEcFormSecureVerifyComponentAccess(ruleParam).subscribe((resp: ApiResponse) => {
            const auxcode = parseInt(resp.code + '', 10);
            if (auxcode === 200) {
                this.showBackOffice = true;
                this.viewDisplay();
            }
            this.blockedDocument = false;
        },
            (err: any) => console.log(err),
            () => {
                this.blockedDocument = false;
            });
    }



    viewDisplay() {
        if (this.showBackOffice) {
            this.itemSelect = 1;
        }
    }

    redirecBack() {
        window.location.assign(this.urlRedirectBackOffice);
    }
}